<nav class="navbar" [ngClass]="toggleSideBar ? 'open' : 'closed'">
  <div class="navbar-left">
    <div class="greeting">Hi, {{userData.name}} 👋</div>
  </div>
  <div class="actions">
    <div class="user-action dropdown">
      <button class="dropdown-toggle" type="button">
        <div class="avatar">
          <span>{{userData.name | initials}}</span>
        </div>
      </button>
      <ul class="dropdown-menu">
        <li class="user-info">
          <div class="avatar">
            <span>{{userData.name | initials}}</span>
          </div>
          <div class="user-details">
            <span class="name">{{userData.name}}</span>
            <span class="email">{{userData.email}}</span>
          </div>
        </li>
        <li class="logout" (click)="logoutUser()">
          <span>Logout</span>
        </li>
      </ul>
    </div>
  </div>
</nav>
